import script from "./FulfillmentMethodWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./FulfillmentMethodWizard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import WizardConfirmModal from "@/components/neue/wizard/WizardConfirmModal.vue";
import WizardNav from "@/components/neue/wizard/WizardNav.vue";
import WizardShell from "@/components/neue/wizard/WizardShell.vue";
script.components = Object.assign({}, { WizardConfirmModal, WizardNav, WizardShell }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { WizardConfirmModal, WizardNav, WizardShell }, script.__o.components);}